import "./AlertDialogComponent.scss";
import {IComponentOptions, IOnInit} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {TradingAlert} from "../../../models/alert/TradingAlert";

export const AlertViewDialog = "tfTradingAlertViewDialog";

interface Resolve {
    alert: TradingAlert;
}

export function alertViewDialog(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/view-dialog/AlertDialogComponent.html`,
        controllerAs: "ctrl",
        controller: AddAlertViewDialogComponentController,
        bindings: {
            resolve: "<",
            modalInstance: "<"
        }
    };
}

export class AddAlertViewDialogComponentController implements IOnInit {

    public readonly resolve: Resolve;
    public alert: TradingAlert;
    public readonly modalInstance: IModalInstanceService;

    /** @ngInject */
    public constructor() {
    }

    public $onInit(): void {
        this.alert = this.resolve.alert;
    }

    public close() {
        this.modalInstance.close();
    }

    public cancel() {
        this.modalInstance.dismiss();
    }

}
